/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PreSearchDataItemStep,
    PreSearchDataItemStepFromJSON,
    PreSearchDataItemStepFromJSONTyped,
    PreSearchDataItemStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface PreSearchDataItem
 */
export interface PreSearchDataItem {
    /**
     * 
     * @type {string}
     * @memberof PreSearchDataItem
     */
    providerName?: string | null;
    /**
     * 
     * @type {Array<PreSearchDataItemStep>}
     * @memberof PreSearchDataItem
     */
    steps?: Array<PreSearchDataItemStep> | null;
}

export function PreSearchDataItemFromJSON(json: any): PreSearchDataItem {
    return PreSearchDataItemFromJSONTyped(json, false);
}

export function PreSearchDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreSearchDataItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerName': !exists(json, 'providerName') ? undefined : json['providerName'],
        'steps': !exists(json, 'steps') ? undefined : (json['steps'] === null ? null : (json['steps'] as Array<any>).map(PreSearchDataItemStepFromJSON)),
    };
}

export function PreSearchDataItemToJSON(value?: PreSearchDataItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerName': value.providerName,
        'steps': value.steps === undefined ? undefined : (value.steps === null ? null : (value.steps as Array<any>).map(PreSearchDataItemStepToJSON)),
    };
}


